import { useState } from "react";
import React from "react";
import Icon from "../components/Icon";
import ConfirmDelete from "../components/ConfirmDelete";
import { fmt } from "../utils";

function PriceList({ t, priceList, addItem, updateItem, deleteItem }) {
  const [search, setSearch] = useState("");
  const [catFilter, setCatFilter] = useState("");
  const [suppFilter, setSuppFilter] = useState("");
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [sortKey, setSortKey] = useState("name");
  const [sortDir, setSortDir] = useState("asc");
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [supplierAC, setSupplierAC] = useState(false);

  const cats = ["Material","Labor","Equipment","Tools","Subcontractor"];
  const suppliers = [...new Set(priceList.map(i=>i.supplier).filter(Boolean))].sort();
  const supplierSuggestions = suppliers.filter(s => !form.supplier || s.toLowerCase().includes(form.supplier.toLowerCase()));
  const margin = (cost,price) => price>0?Math.round((1-cost/price)*100):0;
  const marginClass = (m) => m>=40?"high":m>=25?"mid":"low";

  const handleSort = (key) => {
    if (sortKey === key) setSortDir(d => d==="asc"?"desc":"asc");
    else { setSortKey(key); setSortDir("asc"); }
  };

  const filtered = priceList
    .filter(i=>i.name.toLowerCase().includes(search.toLowerCase())&&(!catFilter||i.category===catFilter)&&(!suppFilter||i.supplier===suppFilter))
    .sort((a,b) => {
      let av = sortKey==="margin" ? margin(a.cost,a.price) : (a[sortKey]||"");
      let bv = sortKey==="margin" ? margin(b.cost,b.price) : (b[sortKey]||"");
      if (typeof av === "string") av = av.toLowerCase();
      if (typeof bv === "string") bv = bv.toLowerCase();
      if (av < bv) return sortDir==="asc"?-1:1;
      if (av > bv) return sortDir==="asc"?1:-1;
      return 0;
    });

  const save = async () => {
    const item={...form,cost:+form.cost||0,price:+form.price||0};
    if(modal==="add") await addItem(item);
    else await updateItem(form.id,item);
    setModal(null);
  };

  const SortTh = ({ label, field, align="left" }) => {
    const active = sortKey===field;
    const arrow = active ? (sortDir==="asc"?" ↑":" ↓") : " ↕";
    return (
      <th
        onClick={()=>handleSort(field)}
        style={{
          textAlign:align, cursor:"pointer", userSelect:"none",
          color: active?"var(--red)":"var(--text-3)",
          whiteSpace:"nowrap",
        }}
      >
        {label}
        <span style={{fontSize:10,opacity:active?1:0.4,marginLeft:3}}>{arrow}</span>
      </th>
    );
  };

  return (
    <div>
      <div className="page-header"><div className="page-header-row"><div><h1>{t.priceList.title}</h1><p>{t.priceList.subtitle}</p></div><button className="btn btn-primary" onClick={()=>{setForm({name:"",category:"Material",unit:"",cost:0,price:0,supplier:""});setModal("add");}}><Icon name="plus" size={14}/>{t.priceList.addBtn}</button></div></div>
      <div className="page-body">
        <div className="toolbar">
          <div className="search-wrap"><Icon name="search"/><input className="search-input" placeholder={t.priceList.search} value={search} onChange={e=>setSearch(e.target.value)}/></div>
          <select className="filter-select" value={catFilter} onChange={e=>setCatFilter(e.target.value)}><option value="">{t.priceList.allCategories}</option>{cats.map(c=><option key={c}>{c}</option>)}</select>
          <select className="filter-select" value={suppFilter} onChange={e=>setSuppFilter(e.target.value)}><option value="">{t.priceList.allSuppliers}</option>{suppliers.map(s=><option key={s}>{s}</option>)}</select>
          <span style={{fontSize:12,color:"var(--text-3)",marginLeft:4}}>{filtered.length} {t.priceList.item?.toLowerCase()}s</span>
        </div>
        <div className="card"><div style={{overflowX:"auto"}}>
          <table>
            <thead>
              <tr>
                <SortTh label={t.priceList.item} field="name"/>
                <SortTh label={t.priceList.category} field="category"/>
                <SortTh label={t.priceList.unit} field="unit"/>
                <SortTh label={t.priceList.cost} field="cost" align="right"/>
                <SortTh label={t.priceList.price} field="price" align="right"/>
                <SortTh label={t.priceList.margin} field="margin" align="right"/>
                <SortTh label={t.priceList.supplier} field="supplier"/>
                <th/>
              </tr>
            </thead>
            <tbody>
              {filtered.map(i=>{
                const m=margin(i.cost,i.price);
                return(
                  <tr key={i.id}>
                    <td style={{fontWeight:500}}>{i.name}</td>
                    <td style={{fontSize:12,color:"var(--text-2)"}}>{i.category}</td>
                    <td style={{color:"var(--text-3)",fontSize:12}}>{i.unit}</td>
                    <td style={{textAlign:"right",fontSize:13}}>{fmt(i.cost)}</td>
                    <td style={{textAlign:"right",fontSize:13,fontWeight:500}}>{fmt(i.price)}</td>
                    <td style={{textAlign:"right"}}><span className={`price-margin ${marginClass(m)}`}>{m}%</span></td>
                    <td style={{fontSize:12,color:"var(--text-2)"}}>{i.supplier}</td>
                    <td><div style={{display:"flex",gap:4}}>
                      <button className="btn-icon" title={t.common.edit} onClick={()=>{setForm({...i});setModal("edit");}}><Icon name="edit" size={13}/></button>
                      <button className="btn-icon danger" title={t.common.delete} onClick={()=>setConfirmDelete(i)}><Icon name="trash" size={13}/></button>
                    </div></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div></div>
      </div>
      {(modal==="add"||modal==="edit")&&(
        <div className="modal-backdrop" onClick={e=>e.target===e.currentTarget&&setModal(null)}>
          <div className="modal">
            <div className="modal-header"><div className="modal-title">{modal==="add"?t.priceList.addTitle:t.priceList.editTitle}</div><button className="btn-icon" title={t.common.close} onClick={()=>setModal(null)}><Icon name="x"/></button></div>
            <div className="modal-body">
              <div className="form-grid form-grid-2">
                <div className="form-group" style={{gridColumn:"1/-1"}}><label>{t.priceList.item} *</label><input className="form-input" value={form.name||""} onChange={e=>setForm(p=>({...p,name:e.target.value}))}/></div>
                <div className="form-group"><label>{t.priceList.category}</label><select className="form-select" value={form.category||"Material"} onChange={e=>setForm(p=>({...p,category:e.target.value}))}>{cats.map(c=><option key={c}>{c}</option>)}</select></div>
                <div className="form-group"><label>{t.priceList.unit}</label><input className="form-input" value={form.unit||""} onChange={e=>setForm(p=>({...p,unit:e.target.value}))}/></div>
                <div className="form-group"><label>{t.priceList.cost} ($)</label><input className="form-input" type="number" value={form.cost||""} onChange={e=>setForm(p=>({...p,cost:e.target.value}))} onFocus={e=>e.target.select()}/></div>
                <div className="form-group"><label>{t.priceList.price} ($)</label><input className="form-input" type="number" value={form.price||""} onChange={e=>setForm(p=>({...p,price:e.target.value}))} onFocus={e=>e.target.select()}/></div>
                <div className="form-group" style={{gridColumn:"1/-1"}}><label>{t.priceList.supplier}</label>
                  <div className="autocomplete-wrap">
                    <input className="form-input" value={form.supplier||""} onChange={e=>setForm(p=>({...p,supplier:e.target.value}))} onFocus={()=>setSupplierAC(true)} onBlur={()=>setTimeout(()=>setSupplierAC(false),150)} autoComplete="off"/>
                    {supplierAC&&supplierSuggestions.length>0&&(
                      <div className="autocomplete-dropdown">
                        {supplierSuggestions.map(s=>(
                          <div key={s} className="autocomplete-item" onMouseDown={e=>{e.preventDefault();setForm(p=>({...p,supplier:s}));setSupplierAC(false);}}>
                            <span className="autocomplete-name">{s}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {form.cost>0&&form.price>0&&<div style={{marginTop:12,padding:"10px 14px",background:"var(--bg)",borderRadius:"var(--radius-sm)",fontSize:13}}>
                Margin: <span className={`price-margin ${marginClass(margin(+form.cost,+form.price))}`}>{margin(+form.cost,+form.price)}%</span>
              </div>}
            </div>
            <div className="modal-footer"><button className="btn btn-secondary" onClick={()=>setModal(null)}>{t.priceList.cancel}</button><button className="btn btn-primary" onClick={save}>{t.priceList.save}</button></div>
          </div>
        </div>
      )}
      {confirmDelete&&<ConfirmDelete message={`Supprimer "${confirmDelete.name}" de la liste de prix?`} onConfirm={()=>{deleteItem(confirmDelete.id);setConfirmDelete(null);}} onCancel={()=>setConfirmDelete(null)}/>}
    </div>
  );
}

export default PriceList;
